import React, { useState } from "react";
import { auth } from "../services/firebase";
import { ReactComponent as FincaIcon } from '../assets/icons/FincaIcon.svg';
import {
  signInWithEmailAndPassword,
} from "firebase/auth";
function Login({ onLoginSuccess }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
const handleAuthAction = async (e) => {
  e.preventDefault();
  setError(null);
  try {
    await signInWithEmailAndPassword(auth, email, password); // Solo se ejecuta la función de inicio de sesión
    console.log("¡Sesión iniciada con éxito!");
    onLoginSuccess();
  } catch (error) {
    console.error("Error de autenticación:", error.code, error.message);
    let errorMessage = "Ocurrió un error. Inténtalo de nuevo.";
    if (error.code === "auth/invalid-email") {
      errorMessage = "El formato del correo electrónico es inválido.";
    } else if (error.code === "auth/wrong-password") {
      errorMessage = "La contraseña es incorrecta.";
    } else if (error.code === "auth/user-not-found") {
      errorMessage = "No se encontró un usuario con este correo.";
    }
    setError(errorMessage);
  }
};
  return (
    <div className="login-container">
        <form className="login-form" onSubmit={handleAuthAction}>
           <FincaIcon className='login-icon' style={{fill:'white'}} />
 <div className="login-form-group" >
            <input
              type="email"
              id="email"
              value={email}
              placeholder="Ingrese su correo"
              className="login-input"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              type="password"
              id="password"
              placeholder="Ingrese su contraseña"
              value={password}
              className="login-input"
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            </div>
          {error && <div className="error-message">{error}</div>}
          <button type="submit" className="login-button">
            Ingresar
          </button>
        </form>
    </div>
  );
}
export default Login;